import { apiRequest } from "./client";

export function listFowebProductBrands() {
  return apiRequest("/fowebproductbrands");
}
